<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-body fluid="xl">
          <b-form @submit.stop.prevent="onSubmit">
            <b-row>
              <b-col lg="12">
                <b-alert show variant="light">Electric Lines Load Report</b-alert>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <hr/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Select Year" label-for="loadYear">
                  <v-select ref="loadYear" id="loadYear" name="loadYear" :class="{ danger: $v.form.loadYear.$error }" @search:blur="$v.form.loadYear.$touch()" :state="validateState('loadYear')"  aria-describedby="liveFeedbackloadYear"  :options="birthYears"  v-model="$v.form.loadYear.$model" ></v-select>
                  <span v-show="$v.form.loadYear.$error" class="danger-span">
                    This is required field
                  </span>
                  <b-form-invalid-feedback id="liveFeedbackloadYear">
                    This is a required field.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <b-button ref="submitButton" type="submit" variant="success" :disabled="$v.form.$invalid">
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
      </b-card-body>
    </b-card>
    <b-card v-if="reportData!=null && Object.keys(reportData).length > 0">
        <ag-grid-vue class="ag-theme-balham"
          :gridOptions="gridOptions"
          id="ElectricLineLoadGrid"
          :rowData="reportData"
          :pagination="true"
          :paginationPageSize="50"
          :suppressNoRowsOverlay="true"
          :floatingFilter="true"
          @gridReady="gridReady">
        </ag-grid-vue>
    </b-card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {AgGridVue} from "ag-grid-vue";
  import VueLodash from 'vue-lodash'
  import map from 'lodash/map'
  import {
    mapState,
    mapActions
  } from 'vuex'

  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";
  const formShape = {
    loadYear: null
  }

  export default {
    name: 'ElectricLineLoad',
    components: {
      AgGridVue
    },
    data: function() {
      return {
        form: Object.assign({}, formShape),
        reportData: null,
        gridOptions: {
          context: {
            componentParent: this
          },
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agNumberColumnFilter',
          },
          columnDefs: [
            {headerName: 'Line', field: 'name', filter: 'agTextColumnFilter', minWidth: 100,maxWidth: 150},
            {headerName: 'Jan', field: 'jan', minWidth: 100,maxWidth: 150},
            {headerName: 'Feb', field: 'feb',minWidth: 100,maxWidth: 150},
            {headerName: 'Mar', field: 'mar', filter: 'agNumberColumnFilter',minWidth: 100,maxWidth: 150},
            {headerName: 'Apr', field: 'apr',filter: 'agNumberColumnFilter',minWidth: 100,maxWidth: 150},
            {headerName: 'May', field: 'may', filter: 'agNumberColumnFilter',minWidth: 100,maxWidth: 150},
            {headerName: 'Jun', field: 'jun',filter: 'agNumberColumnFilter',minWidth: 100,maxWidth: 150},
            {headerName: 'Jul', field: 'jul', filter: 'agNumberColumnFilter',minWidth: 100,maxWidth: 150},
            {headerName: 'Aug', field: 'aug',filter: 'agNumberColumnFilter',minWidth: 100,maxWidth: 150},
            {headerName: 'Sep', field: 'sep',filter: 'agNumberColumnFilter',maxWidth: 150},
            {headerName: 'Oct', field: 'oct',filter: 'agNumberColumnFilter',maxWidth: 150},
            {headerName: 'Nov', field: 'nov',filter: 'agNumberColumnFilter',maxWidth: 150},
            {headerName: 'Dec', field: 'dec',filter: 'agNumberColumnFilter',maxWidth: 150},


         ]
       }
      }
    },
    computed: {
      birthYears () {
       const year = new Date().getFullYear()
       return Array.from({length: year - 1900}, (value, index) => 1901 + index)
      },
      isValid() {
        this.$v.$touch();
        return !this.$v.form.$anyError
      },

    },
    validations: {
      form: {
        loadYear: {
          required
        }
      }
    },
    methods:{
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      },
      onSubmit() {
          if(this.isValid){
          this.$nextTick(() => {
            let params = {
              loadyear: this.$v.form.loadYear.$model
            }
            this.$store.dispatch('electrical/getElectricLineLoad', params)
              .then((response) => {
                if(response.data.success == false){
                    this.showErrorMsg({
                      message: response.data.error
                    });
                }
                else{
                  this.reportData = response.data.data;
                  if(Object.keys(this.reportData).length > 0){
                    this.showSuccessMsg({
                      message: 'Records Retrieved successfully.'
                    });
                  }
                  else{
                    this.showSuccessMsg({
                      message: 'No Records Found for given criteria.'
                    });
                  }

                }
              })
              .catch((error) => {
                if (error.response.status == 400) {
                  this.showErrorMsg({
                    message: error.response.data.message
                  })
                }
                else if (error.response.status == 422){
                    this.showErrorMsg({
                      message: error.response.data.message
                    });

                }
                else {
                  this.showErrorMsg({message: "Something went wrong. Please contact administrator."})
                }
              })

          })
        }
      },
      gridReady(){
         this.gridOptions.api.sizeColumnsToFit();
      },
      onReset() {
        this.form = formShape
        this.$nextTick(() => {
          this.$v.$reset()
        })
      },
    },
  }
</script>

<style media="screen">
  .danger,
  .danger .dropdown-toggle,
  .danger .selected-tag {
    color: #f86c6b;
    border-color: #f86c6b;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f86c6b' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f86c6b' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.95rem) center;
  }
  .danger-span{
    width:100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;

  }

  .borderCard{
    border: 1px solid #e3e8ec;
  }
</style>
